<script setup lang="ts">
import { computed } from 'vue'
import { useTranslate } from '@tolgee/vue'

import { BACKGROUND_ICONS } from '@/api/interfaces'
import { useAccountStore } from '@/stores/Account'
import { useEditorStore } from '@/stores/Editor'

import BaseRadioGroup, { type RadioItem } from '@/components/common/BaseRadioGroup.vue'

const editorStore = useEditorStore()
const accountStore = useAccountStore()
const { t } = useTranslate('local')

const icons: RadioItem[] = BACKGROUND_ICONS.map((icon) => ({
  label: t.value(`EditorBackgroundSettings.icon.${icon}`),
  value: icon,
  imageUrl: `/src/assets/images/editor/background-${icon}-icon.svg`,
}))

const disabled = computed(() => editorStore.publishLoading || accountStore.hasStarterPlan)
</script>

<template>
  <div class="mb-5">
    <BaseRadioGroup
      v-model="editorStore.editor.background.icon"
      :items="icons"
      :disabled="disabled"
      stacked
    />
  </div>
</template>

<style lang="scss" scoped></style>
